import { SxProps } from "@mui/material";

export const PreviewWrapper: SxProps = {
  height: "100%",
  width: "400px",
  overflow: "auto",
  bgcolor: "#fff",

  display: "flex",
  justifyContent: "center",
  py: 3,
  px: 1,
};

export const PreviewContainer: SxProps = {
  width: "100%",
  height: "100%",
  borderRadius: "36px",
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  scrollBehavior: "smooth",
  bgcolor: "#F2F2F7",
  px: 1,
  pt: 5,
  pb: 1,
};
